import applyToOneOrMany from './applyToOneOrMany'

export default function transformWPDateFormat (data) {
  return applyToOneOrMany(_transformWPDateFormat, data)
}

function _transformWPDateFormat (post) {
	post.transformedDate = _transformWPDateRegex(post.date)
  return post
}

function _transformWPDateRegex(string) {
	const regex = /([0-9]{4})-+([0-9]{2})-+([0-9]{2})(.{3}(\:.{2}){2})/g
	const str = string
	const subst = `$3.$2.$1`

	// The substituted value will be contained in the result variable
	const result = str.replace(regex, subst)

	return result
}



// WEBPACK FOOTER //
// ./src/api/util/transformWPDateFormat.js